import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Autocomplete, TextField } from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (contactType: string) => void;
};

const CORE_CONTACT_TYPES = [
  "Abstractor",
  "Buyer",
  "Seller",
  "Buyer's Attorney",
  "Seller's Attorney",
  "Lender's Attorney",
  "Lender",
  "Mortgage Broker",
  "Underwriter",
  "Principal - Buyer",
  "Principal - Seller",
  "Buyer Contact",
  "Seller Contact"
];

const OTHER_CONTACT_TYPES = [
  "1031 Intermediary",
  "Additional Title Company",
  "Assignee",
  "Assigning Lender's Attorney",
  "Assignor",
  "Auctioneer",
  "Authorized Signatory – Borrower (independent)",
  "Authorized Signatory – Borrower (joint)",
  "Authorized Signatory – Buyer (independent)",
  "Authorized Signatory – Buyer (joint)",
  "Authorized Signatory – Seller (independent)",
  "Authorized Signatory – Seller (joint)",
  "Bank Contact",
  "Borrower",
  "Borrower/Lender Consultant",
  "Borrower's General Counsel",
  "Buyer Advisor",
  "Buyer Consultant",
  "Buyer Legal Team",
  "Co-Insurer",
  "Condo Board",
  "copy on emails",
  "Court",
  "Current Owner",
  "Deal Owner",
  "Defendant",
  "Doc Prep",
  "Donor",
  "End Buyer",
  "Escrow Agent",
  "Escrow Payments Borrower",
  "Escrow Payments Seller",
  "Exchange Contact",
  "Exchange Officer",
  "Fee Owner",
  "Filings",
  "Funder",
  "Guarantor",
  "Incoming Member",
  "Inter Agent",
  "Joint Venture",
  "LA - Paralegal",
  "Lakewood Tax",
  "Lead Lender- Capital Partner",
  "Leasehold Owner",
  "Lender's Closer",
  "Lender's Contact",
  "Lien Holder",
  "Limited Access",
  "Loan Officer",
  "Loan Processor",
  "Local Counsel",
  "Local Title Company",
  "Middle Party",
  "Name on application",
  "Name Requested",
  "Name Search",
  "No Access",
  "Notary",
  "NYC Water Board",
  "Old Buyer",
  "Operator",
  "Origination",
  "Outgoing Member",
  "Owner",
  "Payoff Lender",
  "Principal - 1031",
  "Prior Owner",
  "Prior Owner w/o $",
  "Prior Title Company",
  "Realtor",
  "Recordings",
  "Referred By Location",
  "Rundown Name Search",
  "Sales Tax",
  "Seller Exchange",
  "Seller's 1031",
  "Seller's Assistant",
  "Seller's Parent Company",
  "Send Loan Policy to",
  "Surveyor",
  "Tax Certificate",
  "Tax Collector",
  "Team Email",
  "Title Closer",
  "Title Company Client",
  "Title Examination Services",
  "Transaction Coordinator",
  "Trustee",
  "Underwriter's Contact",
  "Vendor",
  "Zoning",
  "Zoning Exhibit"
];

const ALL_CONTACT_TYPES = [...CORE_CONTACT_TYPES, ...OTHER_CONTACT_TYPES];

const ContactTypeChooserModal: React.FC<Props> = ({ open, onClose, onSelect }) => {
  const [selected, setSelected] = useState<string>("");

  const handleContinue = () => {
    if (selected) {
      onSelect(selected);
      setSelected("");
    }
    onClose();
  };

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Select Contact Type</DialogTitle>
        <DialogContent>
          <Autocomplete
              options={ALL_CONTACT_TYPES}
              value={selected}
              onChange={(e, value) => setSelected(value || "")}
              renderInput={(params) => <TextField {...params} label="Contact Type" />}
              sx={{ mt: 2 }}
              fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" disabled={!selected} onClick={handleContinue}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default ContactTypeChooserModal;
